export default "__VITE_ASSET__C7Oy1CvH__"